import { useMemo } from 'react';

import { useUser } from 'store'

import { CATEGORIES_ROLES} from '../../../roles-mapping'

const CATEGORIES_ORDER = [
  'projects',
  'supervision',
  'wifi',
  'codes',
  'stream_cast',
  'documents',
  'support',
  'other',
  'internal'
]

const getCategoriesFiltred = ({ contact, user }) => {
  return CATEGORIES_ROLES.reduce((acc, category) => {
    const roles = Object.keys(category.roles)
      .filter(role => {
        if (['wan_expert', 'admin_fake', 'wifirst_documents'].includes(role)) {
          return !contact
            ? false
            : contact.internal && (user.admin || user.roles[role])
        } else if (role === 'hyperis') {
          return user.admin || (user.internal && user.roles['hyperis'])
        } else if (role === 'demo_mode') {
          return !contact
            ? false
            : user.admin && contact.internal
        }
        return user.admin || user.roles[role]
      })
      .reduce((acc, role) => ({ ...acc, [role]: category[role] }), {})
    if (Object.keys(roles).length) {
      return [...acc, { ...category, roles }]
    } else {
      return acc
    }
  }, [])
}

const useCategories = ({ contact = null } = {}) => {
  const [user] = useUser()
  return useMemo(() => {
    const categories = getCategoriesFiltred({ contact, user })
    return CATEGORIES_ORDER.map(name => {
      return categories.find(cat => cat.name === name)
    }).filter(Boolean)
  }, [contact, user])
}

export default useCategories
